import { useLocation } from 'react-router-dom';

interface StructuredDataProps {
  type: 'artwork' | 'gallery' | 'about' | 'contact';
  data?: any;
}

const StructuredData = ({ type, data }: StructuredDataProps) => {
  const location = useLocation();
  const baseUrl = 'https://w-wagner.art';
  
  const getStructuredData = () => {
    const commonData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "url": `${baseUrl}${location.pathname}`,
      "author": {
        "@type": "Person",
        "name": "Валерия Вагнер",
        "jobTitle": "Художник",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Омск",
          "addressCountry": "RU"
        }
      },
      "publisher": {
        "@type": "Organization",
        "name": "W-Wagner.art",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "ул. 21 Амурская 37, Амур 2",
          "addressLocality": "Омск",
          "addressRegion": "Омская область",
          "addressCountry": "RU"
        }
      }
    };

    switch (type) {
      case 'artwork':
        if (!data) return commonData;
        return {
          ...commonData,
          "@type": "CreativeWork",
          "name": data.title,
          "description": data.description || `Авторская картина "${data.title}" художника Валерии Вагнер из Омска`,
          "image": data.image,
          "creator": {
            "@type": "Person",
            "name": "Валерия Вагнер"
          },
          "artform": "Живопись",
          "artMedium": data.medium || "Масло на холсте",
          "dateCreated": data.year,
          "offers": data.vk_link ? {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "RUB",
            "url": data.vk_link
          } : undefined
        };
        
      case 'gallery':
        return {
          ...commonData,
          "@type": "CollectionPage",
          "name": "Галерея картин художника из Омска - W-Wagner.art",
          "description": "Коллекция авторских картин маслом и акрилом Валерии Вагнер. Живопись, пейзажи, абстракции. Купить картины в Омске.",
          "mainEntity": {
            "@type": "ItemList",
            "name": "Картины художника",
            "description": "Авторские работы Валерии Вагнер"
          }
        };
        
      case 'about':
        return {
          ...commonData,
          "@type": "AboutPage",
          "name": "О художнике Валерии Вагнер из Омска",
          "description": "Профессиональный художник из Омска с 5 лет опыта. Специализация: картины маслом и акрилом.",
          "mainEntity": {
            "@type": "Person",
            "name": "Валерия Вагнер",
            "jobTitle": "Художник",
            "description": "Профессиональный художник из Омска",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Омск",
              "addressCountry": "RU"
            },
            "knowsAbout": ["Живопись маслом", "Акриловая живопись", "Роспись стен"]
          }
        };
        
      case 'contact':
        return {
          ...commonData,
          "@type": "ContactPage",
          "name": "Контакты художника Валерии Вагнер в Омске",
          "description": "Связаться с художником в Омске. Заказать картину, роспись стен. Мастерская в центре Омска.",
          "mainEntity": {
            "@type": "LocalBusiness",
            "name": "Художественная мастерская Валерии Вагнер",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "ул. 21 Амурская 37, Амур 2",
              "addressLocality": "Омск",
              "addressRegion": "Омская область",
              "addressCountry": "RU"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "54.989347",
              "longitude": "73.368221"
            }
          }
        };
        
      default:
        return commonData;
    }
  };

  const structuredData = getStructuredData();

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData, null, 2)
      }}
    />
  );
};

export default StructuredData;